"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { useEffect } from "react";
import formbricks from "@formbricks/js"

export default function FormbricksProvider() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    formbricks.setup({
      environmentId: "cmjb4wt6vmhfrad01g890y3lx",
        appUrl: "https://app.formbricks.com",
    });
  }, []);

  useEffect(() => {
    // ensures Formbricks reacts to route changes (for page view triggers)
    formbricks?.registerRouteChange();
  }, [pathname, searchParams]);

  return null;
}
